import {User} from './user';
import {Project} from './project';
import {Accusation} from './accusation';
import {Player} from './project-player';
import {Label} from './label';
import {PageRequest} from '../pageRequest';
import {PageResponse} from '../pageResponse';
import {Transaction} from './transaction';
import {Detection} from './detection';

export enum ActivityEvent {
  ACCUSATION = 'ACCUSATION',
  DETECTION = 'DETECTION',
  BUILD = 'BUILD'
}


export interface Activity {
  id?: string;
  creationDate?: Date;
  reporter?: User;
  project?: Project;
  player?: Player;
  event?: string;
  title?: string;
  details?: string;
  referenceId?: string;
  accusation?: Accusation;
  detection?: Detection;
  transaction: Transaction;
  label?: Label;
  link?: string[];
}

export class ActivityPageRequest extends PageRequest {
  projectId?: string;
  event?: string;
}

export class ActivityResponse extends PageResponse {
  content: Activity[];
}

export class ActivityBuildResponse extends PageResponse {
  content: Transaction[];
}
